import React from 'react'
import ContentLoader from 'react-content-loader'

// Geometria copiada de inspire-tree-light.css + override de App.css (.inspire-tree)
// para que el skeleton caiga exactamente donde caeran los nodos reales:
//   - fila: 25px de alto (.title height/line-height)
//   - indent: 20px por nivel (.inspire-tree ol ol { padding-left: 20px })
//   - toggle: caja 25x25 en left 0, glifo de 14px centrado -> x = 5.5
//   - icono:  .title::before { left: 24px } -> 14x14
//   - texto:  .title { padding-left: 42px }, centrado en la fila de 25px
const ROW_H = 25
const INDENT = 20
const TOGGLE_X = 5.5
const ICON_X = 24
const TEXT_X = 42
const GLYPH = 14
const TEXT_H = 13

// Misma forma que el arbol real: hub > proyecto > carpeta
const ROWS = [
  { level: 0, width: 70 },
  { level: 1, width: 155 },
  { level: 2, width: 170 },
  { level: 1, width: 120 },
  { level: 2, width: 95 },
]

const WIDTH = 280
const HEIGHT = ROWS.length * ROW_H

const TreeSkeleton = (props) => {
  return (
    // el className replica padding-left/margin del contenedor real del arbol
    <div className="inspire-tree">
      <ContentLoader
        speed={2}
        width={WIDTH}
        height={HEIGHT}
        viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
      >
        {ROWS.map((row, i) => {
          const left = row.level * INDENT
          const top = i * ROW_H
          const glyphY = top + (ROW_H - GLYPH) / 2
          return (
            <React.Fragment key={i}>
              <rect
                x={left + TOGGLE_X}
                y={glyphY}
                rx="3"
                ry="3"
                width={GLYPH}
                height={GLYPH}
              />
              <rect
                x={left + ICON_X}
                y={glyphY}
                rx="3"
                ry="3"
                width={GLYPH}
                height={GLYPH}
              />
              <rect
                x={left + TEXT_X}
                y={top + (ROW_H - TEXT_H) / 2}
                rx="3"
                ry="3"
                width={row.width}
                height={TEXT_H}
              />
            </React.Fragment>
          )
        })}
      </ContentLoader>
    </div>
  )
}

export default TreeSkeleton
